import React, {useState} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import NavBar from '../../../../uiToolkit/NavBar';
import {Col, Container, OverlayTrigger, Row, Tooltip} from 'react-bootstrap';
import {Icon} from '../../../../uiToolkit/Icon/Icon';
import './styles.css';
import {helpConfig, navConfig, contactConfig} from '../navConfig';
import NavListItem from '../components/NavListItem';
import NavGroupItem from '../components/NavGroupItem';
import {OrganizationDetails} from '../../../../data/models/Oganization/Organization';
import MobileRestriction from '../../../../modules/MobileRestriction';
import {CreateOrganization} from '../../../../modules/CreateOrganization';
import OrganizationTitle from '../components/OrganizationTItle';
import TrialExpirationBanner from '../../../../uiToolkit/TrialExpirationBanner/TrialExpirationBanner';
interface Props {
  permissions: string[];
  organization?: OrganizationDetails;
  organizationId?: string;
  hasSubscription?: boolean;
  isDefaultOrgData: boolean;
  trialEnd?: string;
  onCreateOrganization: () => void;
}

const DashboardRootUI = ({
  permissions,
  organizationId,
  organization,
  hasSubscription,
  isDefaultOrgData,
  trialEnd,
  onCreateOrganization,
}: Props) => {
  const location = useLocation();
  const [navHeight, setNavHeight] = useState(0);

  const [menuIsOpen, setMenuIsOpen] = useState(true);
  const [toggleTipShown, setToggleTipShown] = useState(false);
  const toggleLabel = menuIsOpen ? 'Collapse sidebar' : 'Expand sidebar';
  const toggleIcon = menuIsOpen
    ? 'studio-panel-left-close.svg'
    : 'studio-panel-left-open.svg';

  const toggleMenu = () => {
    // Hide the tooltip so it does not trail the button to its new position.
    setToggleTipShown(false);
    setMenuIsOpen(isOpen => !isOpen);
  };

  return (
    <div className="DashboardRoot">
      <NavBar onHeightCalculated={setNavHeight} />
      <CreateOrganization
        isOpen={isDefaultOrgData}
        onClose={onCreateOrganization}
      />
      <TrialExpirationBanner
        expirationDate={trialEnd}
        organizationId={organizationId}
      />
      <Container fluid>
        <Row>
          <Col
            lg={menuIsOpen ? 2 : 1}
            className={`DashboardRootSideNav d-none d-lg-block ${
              menuIsOpen ? 'SideNavOpen' : 'SideNavCollapsed'
            }`}
            style={{height: `calc(100vh - ${navHeight}px)`}}>
            <div className="NavItemsList">
              <div
                className={`SidebarHeader ${
                  menuIsOpen ? '' : 'SidebarHeaderCollapsed'
                }`}>
                {organization && (
                  <div className="SidebarHeaderOrg">
                    <OrganizationTitle
                      organization={organization}
                      menuIsOpen={menuIsOpen}
                    />
                  </div>
                )}
                <OverlayTrigger
                  placement={menuIsOpen ? 'bottom' : 'right'}
                  show={toggleTipShown}
                  onToggle={setToggleTipShown}
                  overlay={
                    <Tooltip
                      id="sidebar-toggle-tooltip"
                      className="SidebarToggleTooltip">
                      {toggleLabel}
                    </Tooltip>
                  }>
                  <button
                    type="button"
                    className="SidebarToggle"
                    onClick={toggleMenu}
                    aria-label={toggleLabel}
                    aria-expanded={menuIsOpen}>
                    <span className="SidebarToggleIcon" aria-hidden="true">
                      <Icon name={toggleIcon} />
                    </span>
                  </button>
                </OverlayTrigger>
              </div>
              {navConfig(organizationId).map(item => {
                if (item.reqireSubscription && !hasSubscription) return null;
                return item.items ? (
                  <NavGroupItem
                    {...item}
                    items={item.items}
                    activeRoute={location.pathname}
                    key={item.title}
                    userPermissions={permissions}
                    collapsed={!menuIsOpen}
                    hasSubscription={hasSubscription}
                  />
                ) : (
                  <NavListItem
                    {...item}
                    activeRoute={location.pathname}
                    key={item.title}
                    userPermissions={permissions}
                    collapsed={!menuIsOpen}
                  />
                );
              })}
            </div>
            <div className="Divider" />
            <NavListItem
              {...helpConfig}
              activeRoute={location.pathname}
              key={helpConfig.title}
              userPermissions={permissions}
              collapsed={!menuIsOpen}
              newTab
            />
            <NavListItem
              {...contactConfig}
              activeRoute={location.pathname}
              key={contactConfig.title}
              userPermissions={permissions}
              collapsed={!menuIsOpen}
              newTab
            />
          </Col>
          <Col
            lg={menuIsOpen ? 10 : 11}
            xs={12}
            className="DashboardRootContent ContentBesideNav d-none d-lg-block px-4"
            style={{height: `calc(100vh - ${navHeight}px)`}}>
            <Outlet />
          </Col>
          <Col
            xs={12}
            className="DashboardRootContent d-lg-none d-block px-4"
            style={{height: `calc(100vh - ${navHeight}px)`}}>
            <MobileRestriction />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default DashboardRootUI;
